module.exports = __webpack_public_path__ + "img/freespin_multiplier.6c85634d.png";